<p-card>
	<div class="under-maintenance-content">
		<h1>Under maintenance</h1>
		<div>This application is currently under maintenance.</div>
		<div>Please check back later.</div>
	</div>
</p-card>
